import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import clsx from 'clsx';
import { VALUE_CHAIN_AI_AGENT } from 'constants/general';

import type { TAIGeneratingCardStatus } from '../../interfaces/IAIGeneratingModal';
import type IAIGeneratingModalListItem from './interfaces/IAIGeneratingModalListItem';

import styles from './sass/AIGeneratingModalListItem.module.scss';

function AIGeneratingModalListItem({
  item,
  card,
  onCardClick,
}: IAIGeneratingModalListItem) {
  const { t } = useTranslation();

  const getStatusLabelKey = (status: TAIGeneratingCardStatus): string => {
    if (status === VALUE_CHAIN_AI_AGENT.STATUS_DONE) {
      return 'valueChainMap.aiGeneratingStatusDone';
    }

    if (status === VALUE_CHAIN_AI_AGENT.STATUS_IN_PROGRESS) {
      return 'valueChainMap.aiGeneratingStatusInProgress';
    }

    return 'valueChainMap.aiGeneratingStatusEmpty';
  };

  const handleCardClick = () => {
    onCardClick(card);
  };

  return (
    <button
      type="button"
      className={styles.itemButton}
      onClick={handleCardClick}
      aria-label={`${item.name}. ${t(getStatusLabelKey(item.status))}`}
    >
      <span
        className={clsx(
          styles.statusIndicator,
          styles[`status_${item.status}`],
        )}
        aria-hidden="true"
      >
        {item.status === VALUE_CHAIN_AI_AGENT.STATUS_DONE ? (
          <CheckIcon className={styles.checkIcon} />
        ) : null}
        {item.status === VALUE_CHAIN_AI_AGENT.STATUS_IN_PROGRESS ? (
          <span className={styles.spinner} />
        ) : null}
      </span>
      <span className={styles.itemTitle}>{item.name}</span>
    </button>
  );
}

export default AIGeneratingModalListItem;
